import React from "react";
import PropTypes from "prop-types";
import Img from "gatsby-image";
import { Box, Text } from "rebass";

export const BannerBlock = ({ caption, img }) => {
  return (
    <Box>
      <Box mb="2rem">
        <Img fluid={img.childImageSharp.fluid} width="auto" height="auto" />
      </Box>

      <Text variant="heroSubtitle" fontSize={["sm", "sm"]} textAlign="center">
        {caption}
      </Text>
    </Box>
  );
};

BannerBlock.propTypes = {
  caption: PropTypes.string,
  img: PropTypes.string.isRequired,
};
